// extracted by mini-css-extract-plugin
export var connectionButton = "_91-1";
export var rightPanel = "_91-3";
export var stepDescription = "_91-2";
export var stepIcon = "_91-0";